import { base } from "@base-provider";

export const getSkillPathPreview = (id) => {
  return base.get({
    url: `/content-studio/skills-path/${id}/preview`,
  });
};